$(document).on('click', '[data-app-password-eye]', function () {
    $(this).toggleClass('active');
    var $input = $(this).parent().find('input');
    if( $input.attr('type') === 'password'){
        $input.attr('type', 'text');
    }
    else{
        $input.attr('type', 'password');
    }
});
